'use strict';

var Util = require('./util/index');
var NOOP = function NOOP() {};

// 封装 AJAX 接口
module.exports = function (opts) {
    if (!opts) return;

    var UA = Util.getUserAgent();
    var browserName = Util.getAppName();
    var isIE89 = browserName.indexOf('Microsoft Internet Explorer') !== -1 && (UA.indexOf('MSIE 8.0') !== -1 || UA.indexOf('MSIE 9.0') !== -1);
    var useXDomainRequest = isIE89 && window.XDomainRequest;

    var req = void 0;
    if (useXDomainRequest) {
        req = new XDomainRequest();
    } else {
        req = new XMLHttpRequest();
    }

    req.open(opts.type || 'GET', opts.url, true);
    req.success = opts.success || NOOP;
    req.fail = opts.fail || NOOP;

    var _handleXhrEvent = function _handleXhrEvent(event) {
        if (event && event.currentTarget && /catfront.(dianping|51ping).com/.test(opts.url)) {
            if (event.currentTarget.status === 200) {
                req.success && req.success();
            } else {
                req.fail && req.fail();
            }
        }
    };

    // 当设置了 autoCatch.ajax 为false时，也需要支持 success/fail 回调
    if (opts.xhrRewritten === false && !useXDomainRequest) {
        if ('addEventListener' in req) {
            req.addEventListener('load', _handleXhrEvent);
            req.addEventListener('error', _handleXhrEvent);
            req.addEventListener('abort', _handleXhrEvent);
        } else {
            var _originStateChange = req.onreadystatechange;
            req.onreadystatechange = function (event) {
                if (this.readyState === 4) {
                    _handleXhrEvent(event);
                }
                if (_originStateChange) {
                    _originStateChange.apply(this, arguments);
                }
            };
        }
    }

    if (opts.type === 'POST') {
        if (opts.header && !useXDomainRequest) {
            for (var key in opts.header) {
                if (opts.header.hasOwnProperty(key)) {
                    req.setRequestHeader(key, opts.header[key]);
                }
            }
        }
        req.send(opts.data);
    } else {
        req.send();
    }

    return req;
};